import { feedback } from '@ecosystem/newron-design-system';
import * as styles from './LoadingOverlay.module.scss';

interface Props {
  loadingOverlay: boolean;
}

const LoadingOverlay: React.FC<Props> = ({ loadingOverlay }) => {
  return loadingOverlay ? (
    <>
      <div data-testid="loading-icon" className={`${styles.loading} z-index-modal`}>
        <feedback.DotsLoader />
      </div>
      <div className={`${styles.overlay} z-index-modal-overlay`}></div>
    </>
  ) : null;
};

export default LoadingOverlay;
